import React, { Fragment, useState, useEffect } from 'react';
import { Button, Form, Alert, Col, Row, Container } from 'react-bootstrap';
import { Link, useParams, Navigate } from 'react-router-dom';
import SolicitacaoService from '../../../../../services/solicitacao';


const Componente = () => {
    let { id } = useParams()
    const [responsavel, setResponsavel] = useState("");
    const [secretaria, setSecretaria] = useState("");
    const [email, setEmail] = useState("");
    const [processo, setProcesso] = useState("");
    const [numeroMemorando, setNumeroMemorando] = useState("");
    const [error, setError] = useState([]);
    const [sucesso, setSucesso] = useState(false);
    const [redirect, setRedirect] = useState(false);
    const [situacao, setSituacao] = useState("");

    async function fetchSolic(id) {
        const response = await SolicitacaoService.solicEdit(id);
        setResponsavel(response.data["responsavel"]);
        setSecretaria(response.data["secretaria"]);
        setProcesso(response.data["processo"]);
        setNumeroMemorando(response.data["numeroMemorando"]);
        setEmail(response.data["email"]);
        if (response.data["situacao"] === "Pendente") {
            setSituacao("pendentes")
        } else {
            setSituacao("respondidas")
        }
    }

    useEffect(() => {
        fetchSolic(id);
    }, [id]);


    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        try {
            const sol = await SolicitacaoService.editar(id, {
                responsavel: responsavel,
                secretaria: secretaria,
                email: email,
                numeroMemorando: numeroMemorando,
                processo: processo
            })
            if (sol.data["_id"]) {
                setSucesso(true)
                setError(false)
            } else {
                setError("Deu algo errado no cadastro!")
            }
        } catch (error) {
            setError(error)
        }
    }

    if (sucesso && !redirect) {
        setTimeout(() => {
            setRedirect(true);
        }, 3000); // 3 segundos
    }

    // Quando redirect virar true → redireciona
    if (redirect) {
        return <Navigate to="/ti/solicitacao/listar" />;
    }

    if (!sucesso) {
        return (
            <Fragment>
                <Container>
                    <Row xs={12}>
                        <Form onSubmit={HandleSubmit} >
                            <Row xs={12} lg={4}>
                                <Col xs={12} lg={12}>
                                    <Form.Group className="mb-3" controlId="responsavel">
                                        <Form.Label>Responsável</Form.Label>
                                        <Form.Control
                                            required
                                            type="text"
                                            name="responsavel"
                                            value={responsavel}
                                            onChange={e => setResponsavel(e.target.value)} />
                                    </Form.Group>
                                </Col>
                                <Col xs={12} lg={6}>
                                    <Form.Group controlId="selectSecretaria">
                                        <Form.Label>Secretaria</Form.Label>
                                        <Form.Select required onChange={e => setSecretaria(e.target.value)}>
                                            <option value={secretaria}>{secretaria}</option>
                                            <option>SELECIONE</option>
                                            <option value="Secretaria Municipal de Segurança Pública, Administração e Mobilidade Urbana">Segurança Pública, Administração e Mobilidade Urbana</option>
                                            <option value="Secretaria Municipal de Agricultura, Pecuária, Abastecimento e Aquicultura">Agricultura, Pecuária, Abastecimento e Aquicultura</option>
                                            <option value="Secretaria Municipal de Educação">Educação</option>
                                            <option value="Secretaria Municipal de Esporte, Lazer, Turismo e Cultura">Esporte, Lazer, Turismo e Cultura</option>
                                            <option value="Secretaria Municipal de Fazenda, Planejamento, Orçamento, Indústria e Comércio">Fazenda, Planejamento, Orçamento, Indústria e Comércio</option>
                                            <option value="Secretaria Municipal de Gabinete e Comunicação">Gabinete e Comunicação</option>
                                            <option value="Secretaria Municipal de Controle Interno">Controle Interno</option>
                                            <option value="Secretaria Municipal de Governo e Gestão">Governo e Gestão</option>
                                            <option value="Secretaria Municipal de Meio Ambiente, Urbanismo e Defesa Civil">Meio Ambiente, Urbanismo e Defesa Civil</option>
                                            <option value="Secretaria Municipal de Obras e Serviços Públicos">Obras e Serviços Públicos</option>
                                            <option value="Secretaria Municipal de Saúde e Prevenção à Dependência Química">Saúde e Prevenção à Dependência Química</option>
                                            <option value="Secretaria Municipal de Desenvolvimento Social e Direitos Humanos">Desenvolvimento Social e Direitos Humanos</option>
                                            <option value="Secretaria Municipal de Trabalho, Envelhecimento Saudável e da Juventude">Trabalho, Envelhecimento Saudável e da Juventude</option>
                                            <option value="Departamento de Patrimônio">Patrimônio</option>
                                            <option value="Departamento de Turismo">Turismo</option>
                                            <option value="Departamento de Cultura">Cultura</option>
                                            <option value="Junta Militar de Macuco">Junta Militar de Macuco</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                <Col xs={12} lg={2}>
                                    <Form.Group className="mb-3" controlId="processo">
                                        <Form.Label>Processo</Form.Label>
                                        <Form.Control
                                            required
                                            type="text"
                                            name="processo"
                                            value={processo}
                                            onChange={e => setProcesso(e.target.value)} />
                                    </Form.Group>
                                </Col>
                                <Col xs={12} lg={2}>
                                    <Form.Group className="mb-3" controlId="numeroMemorando">
                                        <Form.Label>Memorando</Form.Label>
                                        <Form.Control
                                            required
                                            type="text"
                                            name="numeroMemorando"
                                            value={numeroMemorando}
                                            onChange={e => setNumeroMemorando(e.target.value)} />
                                    </Form.Group>
                                </Col>
                                <Col xs={12} lg={4}>
                                    <Form.Group className="mb-3" controlId="email">
                                        <Form.Label>E-mail</Form.Label>
                                        <Form.Control
                                            required
                                            type="text"
                                            name="email"
                                            value={email}
                                            onChange={e => setEmail(e.target.value)}
                                        />
                                    </Form.Group>
                                </Col>
                                {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                            </Row>
                            <Row>
                                <Col xs={12} lg={3}>
                                    <Button variant="success" type="submit">
                                        Salvar
                                    </Button>
                                </Col>
                            </Row>
                        </Form >
                    </Row>
                    <br />
                    <Link to={`/ti/solicitacao/${situacao}`}>
                        <Button variant="danger" type="button">
                            Cancelar
                        </Button>
                    </Link>
                </Container>
            </Fragment >
        )
    } else {
        return (
            <Fragment>
                <Container>
                    <Alert variant='success'>
                        Solicitação editada com sucesso!<br />
                        Redirecionando em 3 segundos...
                    </Alert>
                </Container>
            </Fragment>
        )
    }
}

export default Componente;